export * from './lib/access-control-api.module';
export * from './lib/services/permissions-api.service';
